function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(require.context('./images/posters', false, /\.(png|jpe?g|svg)$/));

function shuffle(array) {
  // const array = [...arr];
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

shuffle(images);

const initialState = {
  campaigns: {
    active: [
      {
        id: 0,
        eventId:  0, 
        type: 'facebook',
        name: 'First Facebook Campaign',
        preview: images[0],
        content: {
          descr: 'jnkj',
          title: 'njknjk',
          url: 'hjbhjbhj',
          image: images[0],
        },
        stats: {
          impressions: 1456,
          openrate: 33,
          clickrate: 6,
          cta: 101,
        },
        active: true,
      },
      {
        id: 1,
        eventId:  0, 
        type: 'email',
        name: 'First Email Campaign',
        preview: images[1],
        content: {
          subject: 'jnkj',
          text: 'njknjk',
        },
        stats: {
          impressions: 4147,
          openrate: 21,
          clickrate: 3,
          cta: 101,
        },
        active: true,
      },
      {
        id: 2,
        eventId:  0, 
        type: 'facebook',
        name: 'Second Facebook Campaign',
        preview: images[2],
        content: {
          descr: 'jnkj',
          title: 'njknjk',
          url: 'hjbhjbhj',
          image: images[2],
        },
        stats: {
          impressions: 2486,
          openrate: 14,
          clickrate: 5,
          cta: 101,
        },
        active: false,
      },
      {
        id: 3,
        eventId:  0, 
        type: 'push',
        name: 'First Push Campaign',
        preview: images[3],
        content: {
          title: 'njknjk',
          message: 'jnkj',
          url: 'hjbhjbhj',
        },
        stats: {
          impressions: 3437,
          openrate: 27,
          clickrate: 9,
          cta: 101,
        },
        active: true,
      },
      {
        id: 4,
        eventId:  0, 
        type: 'sms',
        name: 'First SMS Campaign',
        preview: images[4],
        content: {
          body: 'Hi there!',
        },
        stats: {
          impressions: 2876,
          openrate: 41,
          clickrate: 5,
          cta: 101,
        },
        active: true,
      },
      {
        id: 5,
        eventId:  1, 
        type: 'facebook',
        name: 'First Facebook Campaign',
        preview: images[5],
        content: {
          descr: 'jnkj',
          title: 'njknjk',
          url: 'hjbhjbhj',
          image: images[5],
        },
        stats: {
          impressions: 1598,
          openrate: 31,
          clickrate: 4,
          cta: 101,
        },
        active: true,
      },
      {
        id: 6,
        eventId:  1, 
        type: 'email',
        name: 'First Email Campaign',
        preview: images[6],
        content: {
          subject: 'jnkj',
          text: 'njknjk',
        },
        stats: {
          impressions: 3692,
          openrate: 13,
          clickrate: 4,
          cta: 101,
        },
        active: true,
      },
      {
        id: 7,
        eventId:  1, 
        type: 'email',
        name: 'First Email Campaign',
        preview: images[7],
        content: {
          subject: 'jnkj',
          text: 'njknjk',
        },
        stats: {
          impressions: 1478,
          openrate: 15,
          clickrate: 6,
          cta: 101,
        },
        active: true,
      },
      {
        id: 8,
        eventId:  2, 
        type: 'facebook',
        name: 'Second Facebook Campaign',
        preview: images[8],
        content: {
          descr: 'jnkj',
          title: 'njknjk',
          url: 'hjbhjbhj',
          image: images[8],
        },
        stats: {
          impressions: 1452,
          openrate: 35,
          clickrate: 8,
          cta: 101,
        },
        active: true,
      },
      {
        id: 9,
        eventId:  2, 
        type: 'push',
        name: 'First Push Campaign',
        preview: images[9],
        content: {
          title: 'njknjk',
          message: 'jnkj',
          url: 'hjbhjbhj',
        },
        stats: {
          impressions: 3578,
          openrate: 33,
          clickrate: 6,
          cta: 101,
        },
        active: true,
      },
      {
        id: 10,
        eventId: 3, 
        type: 'sms',
        name: 'First SMS Campaign',
        preview: images[10],
        content: {
          body: 'Hi there!',
        },
        stats: {
          impressions: 4536,
          openrate: 21,
          clickrate: 3,
          cta: 101,
        },
        active: true,
      },
      {
        id: 11,
        eventId: 3, 
        type: 'facebook',
        name: 'First Facebook Campaign',
        preview: images[11],
        content: {
          descr: 'jnkj',
          title: 'njknjk',
          url: 'hjbhjbhj',
          image: images[11],
        },
        stats: {
          impressions: 3575,
          openrate: 14,
          clickrate: 5,
          cta: 101,
        },
        active: true,
      },
      {
        id: 12,
        eventId: 3, 
        type: 'email',
        name: 'First Email Campaign',
        preview: images[12],
        content: {
          subject: 'jnkj',
          text: 'njknjk',
        },
        stats: {
          impressions: 4862,
          openrate: 25,
          clickrate: 7,
          cta: 101,
        },
        active: true,
      },
      {
        id: 13,
        eventId: 4, 
        type: 'facebook',
        name: 'Second Facebook Campaign',
        preview: images[13],
        content: {
          descr: 'jnkj',
          title: 'njknjk',
          url: 'hjbhjbhj',
          image: images[13],
        },
        stats: {
          impressions: 2684,
          openrate: 12,
          clickrate: 3,
          cta: 101,
        },
        active: true,
      },
      {
        id: 14,
        eventId: 5, 
        type: 'sms',
        name: 'First SMS Campaign',
        preview: images[14],
        content: {
          body: 'Hi there!',
        },
        stats: {
          impressions: 1245,
          openrate: 31,
          clickrate: 4,
          cta: 101,
        },
        active: true,
      },
    ],
    saved: [],
  },
  segments: [
    {
      id: 0,
      name: 'Everyone who likes deep house',
      params: {
        request: 'deep house',
        country: '',
        state: '',
        gender: '',
        medium: [],
        age: [],
        influence: 100,
        conversion: 100,
        spending: [],
        attending: 10,
      },
      data: {
        new: 14,
        unengaged: 83,
        regulars: 3,
      },
    },
    {
      id: 1,
      name: 'Everyone who likes Beyonce',
      params: {
        request: 'Beyonce',
        country: '',
        state: '',
        gender: '',
        medium: [],
        age: [],
        influence: 100,
        conversion: 100,
        spending: [],
        attending: 10,
      },
      data: {
        new: 22,
        unengaged: 42,
        regulars: 36,
      },
    },
    {
      id: 2,
      name: 'Everyone who likes Nick Cave & The Bad Seeds',
      params: {
        request: 'Nick Cave & The Bad Seeds',
        country: '',
        state: '',
        gender: '',
        medium: [],
        age: [],
        influence: 100,
        conversion: 100,
        spending: [],
        attending: 10,
      },
      data: {
        new: 20,
        unengaged: 62,
        regulars: 18,
      },
    },
    {
      id: 3,
      name: 'Everyone who likes country music',
      params: {
        request: 'country music',
        country: '',
        state: '',
        gender: '',
        medium: [],
        age: [],
        influence: 100,
        conversion: 100,
        spending: [],
        attending: 10,
      },
      data: {
        new: 8,
        unengaged: 90,
        regulars: 2,
      },
    },
    {
      id: 4,
      name: 'Everyone who likes Kendrick Lamar',
      params: {
        request: 'Kendrick Lamar',
        country: '',
        state: '',
        gender: '',
        medium: [],
        age: [],
        influence: 100,
        conversion: 100,
        spending: [],
        attending: 10,
      },
      data: {
        new: 11,
        unengaged: 71,
        regulars: 18,
      },
    },
    {
      id: 5,
      name: 'Everyone who likes jazz & blues music',
      params: {
        request: 'jazz & blues music',
        country: '',
        state: '',
        gender: '',
        medium: [],
        age: [],
        influence: 100,
        conversion: 100,
        spending: [],
        attending: 10,
      },
      data: {
        new: 19,
        unengaged: 79,
        regulars: 2,
      },
    },
  ],
  events: [
    {
      id: 0,
      name: 'Event Name',
      preview: images[0],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '09.12.2017 23:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 1456,
        openrate: 33,
        clickrate: 6,
        cta: 101,
      }
    },
    {
      id: 1,
      name: 'Event Name',
      preview: images[1],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '10.12.2017 23:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 4147,
        openrate: 21,
        clickrate: 3,
        cta: 101,
      }
    },
    {
      id: 2,
      name: 'Event Name',
      preview: images[2],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '11.12.2017 20:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 2486,
        openrate: 14,
        clickrate: 5,
        cta: 101,
      }
    },
    {
      id: 3,
      name: 'Event Name',
      preview: images[3],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '12.12.2017 18:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 3437,
        openrate: 27,
        clickrate: 9,
        cta: 101,
      }
    },
    {
      id: 4,
      name: 'Event Name',
      preview: images[4],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '13.12.2017 23:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 2876,
        openrate: 41,
        clickrate: 5,
        cta: 101,
      }
    },
    {
      id: 5,
      name: 'Event Name',
      preview: images[5],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '14.12.2017 21:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 1598,
        openrate: 31,
        clickrate: 4,
        cta: 101,
      }
    },
    {
      id: 6,
      name: 'Event Name',
      preview: images[6],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '15.12.2017 22:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 3692,
        openrate: 13,
        clickrate: 4,
        cta: 101,
      }
    },
    {
      id: 7,
      name: 'Event Name',
      preview: images[7],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '16.12.2017 16:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 1478,
        openrate: 15,
        clickrate: 6,
        cta: 101,
      }
    },
    {
      id: 8,
      name: 'Event Name',
      preview: images[8],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '17.12.2017 23:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 1452,
        openrate: 35,
        clickrate: 8,
        cta: 101,
      }
    },
    {
      id: 9,
      name: 'Event Name',
      preview: images[9],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '18.12.2017 00:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 3578,
        openrate: 33,
        clickrate: 6,
        cta: 101,
      }
    },
    {
      id: 10,
      name: 'Event Name',
      preview: images[10],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '19.12.2017 19:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 4536,
        openrate: 21,
        clickrate: 3,
        cta: 101,
      }
    },
    {
      id: 11,
      name: 'Event Name',
      preview: images[11],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '20.12.2017 22:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 3575,
        openrate: 14,
        clickrate: 5,
        cta: 101,
      }
    },
    {
      id: 12,
      name: 'Event Name',
      preview: images[12],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '21.12.2017 23:00',
      url: 'http://festivality.co',

      stats: {
        impressions: 4862,
        openrate: 25,
        clickrate: 7,
        cta: 101,
      }
    },
    {
      id: 13,
      name: 'Event Name',
      preview: images[13],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '22.12.2017 20:00',
      url: 'http://festivality.co',
      
      stats: {
        impressions: 2684,
        openrate: 12,
        clickrate: 3,
        cta: 101,
      }
    },
    {
      id: 14,
      name: 'Event Name',
      preview: images[14],
      description: 'Event Description',
      location: 'Event Description',
      datetime: '23.12.2017 19:00',
      url: 'http://festivality.co',
      
      stats: {
        impressions: 1245,
        openrate: 31,
        clickrate: 4,
        cta: 101,
      }
    },
  ],
}

shuffle(initialState.campaigns.active)

export default initialState


// WEBPACK FOOTER //
// ./src/initialState.js